<template>
  <div class="footer">
    <div class="foo-con">
      <div class="con-1">
        <div class="cpzx">产品中心</div>
        <div class="cpzx-con">
          <a href="https://muke.jycyfww.com" target="_blank">东云启创在线学习平台</a>
          <a href="http://www.dongyunqichuang.com/busion" target="_blank">东云启创创业实训平台</a>
          <a href="https://ceping.jycyfww.com" target="_blank">创新·就业·创业测评平台</a>
          <a href="http://www.dongyunqichuang.com/wangchuang" target="_blank">东云启创网络创业实训平台</a>
        </div>
      </div>
      <div class="con-1">
        <div class="cpzx-con">
          <a href="https://jycyfww.com/zhibo" target="_blank">启创直播</a> 
          <a href="https://jycyfww.com" target="_blank">就业创业服务网</a>
        </div>
      </div>
      <div class="con-1">
        <div class="cpzx">联系我们</div>
        <div class="cpzx-con">
          <a href="#">电话:{{info.phone}}</a>
          <a href="#">邮箱:{{info.email}}</a>
          <a href="#">地址:{{info.address}}</a>
        </div>
      </div>
      <div class="wximg-box">
        <div style="margin-right:20px">
          <img class="wx-img" :src="info.qrCode1" alt="">
          <div>{{info.qrCodeName1}}</div>
        </div>
        <div>
          <img class="wx-img" :src="info.qrCode2" alt="">
          <div>{{info.qrCodeName2}}</div>
        </div>
      </div>
    </div>
    <div class="foo-foo">启创未来（北京）科技有限公司©2025 <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备16052847号-2</a></div>
  </div>
</template>

<script>
import { getHome } from "@/api/index.js";
export default {
  name: "home-footer",
  data() {
    return {
      info: {}
    };
  },
  mounted() {
    getHome().then((res) => {
      if (res.status == 200) {
        this.info = res.data;
      }
    });
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  width: 100%;
  height: 413px;
  background-color: #0f1115;
 /* position: relative;; */
  /* bottom: 412px; */
  /* margin-top: 1px; */
}
.wx-img {
  width: 150px;
  height: 150px;
  /* margin-bottom: 20px;
  margin-left: 35px; */
  /* margin-right: 20px; */
}
.wximg-box {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  opacity: 0.9;
  text-align: center;
  display: flex;
  justify-content: space-between;
  
}
.foo-foo,
.foo-foo a {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  text-align: center;
  line-height: 74px;
  text-decoration: none;
}
.foo-con {
  width: 1200px;
  height: 338px;
  padding-right: 100px;
  margin: 0 auto;
  border-bottom: 1px solid #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cpzx {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 10px;
}
.con-1 {
  margin-right: 20px;
}
.con-1 a {
  display: block;
  color: #fff;
  text-decoration: none;

}
.cpzx-con a{
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue